// JsFromRoutes CacheKey a3af4f6bb64cb4634846d5cbdb66bdf9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/template_packs/imports/avvoka'),
}
